import { render, staticRenderFns } from "./AllCommentsModal.vue?vue&type=template&id=744aaf90"
import script from "./AllCommentsModal.vue?vue&type=script&lang=js"
export * from "./AllCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./AllCommentsModal.vue?vue&type=style&index=0&id=744aaf90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports